/**
 * Barrel export for authorization models
 * Enables importing all types from a single location
 */
export * from './role.enum';
export * from './access-type.enum';
export * from './privilege.interface';
export * from './user-context.interface';
export * from './route-authorization-data.interface';
